import styled, { createGlobalStyle } from 'styled-components';
import { theme as antTheme } from 'antd';
import { colors } from 'settings/style';
import {
  LoginModal,
  StyledForm,
  TEXT_MUTED,
  BORDER_INPUT,
} from 'components/login/login.styled';

export { LoginBody, LoginHeading, LoginSubheading, LogoMark, SignInButton, LoginFooter, SignUpLink } from 'components/login/login.styled';

export const ContactModalShell = LoginModal;

export const ContactStyledForm = styled(StyledForm)`
  .contact-autocomplete {
    width: 100%;
  }

  .contact-autocomplete .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    height: auto !important;
    background: transparent !important;
  }

  .contact-autocomplete.ant-select-focused .ant-select-selector {
    box-shadow: none !important;
  }
`;

export const ContactOptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContactOptionText = styled.div`
  min-width: 0;
`;

export const ContactOptionName = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${colors.grey900};
  line-height: 1.3;
`;

export const ContactOptionMeta = styled.div`
  font-size: 0.75rem;
  color: #667085;
  line-height: 1.3;
`;

/** Dropdown is portaled; force light surface (overrides parent dark theme on family tree). */
export const ContactDropdownGlobalStyle = createGlobalStyle`
  .contact-modal-autocomplete-dropdown.ant-select-dropdown {
    --antd-arrow-background-color: #ffffff;
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 8px;
    border: 1px solid ${BORDER_INPUT};
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
    padding: 4px;
  }

  .contact-modal-autocomplete-dropdown .rc-virtual-list,
  .contact-modal-autocomplete-dropdown .rc-virtual-list-holder,
  .contact-modal-autocomplete-dropdown .rc-virtual-list-holder-inner {
    background: #ffffff !important;
    background-color: #ffffff !important;
  }

  .contact-modal-autocomplete-dropdown .ant-select-item {
    border-radius: 6px;
    padding: 8px 10px;
    color: ${colors.grey900} !important;
    background: #ffffff !important;
    background-color: #ffffff !important;
  }

  .contact-modal-autocomplete-dropdown .ant-select-item-option-active,
  .contact-modal-autocomplete-dropdown .ant-select-item-option-selected {
    background: #f2f4f7 !important;
    background-color: #f2f4f7 !important;
  }

  .contact-modal-autocomplete-dropdown .ant-empty-description {
    color: ${TEXT_MUTED};
  }
`;

/** Light Ant Design theme so portaled autocomplete popup is not dark-themed (e.g. on family tree). */
export const contactModalLightTheme = {
  algorithm: antTheme.defaultAlgorithm,
  token: {
    colorBgElevated: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgBase: '#ffffff',
    colorText: colors.grey900,
    colorTextDescription: TEXT_MUTED,
  },
};
